import { NAMESPACE } from "./_Namespace";

export type AbstractConstructor = abstract new (...args: any[]) => any;

export type Constructor<T = unknown> = {
    new(...args: any[]): T;
    name: string;
}

export type PartialNullable<T> = {
    [P in keyof T]?: Nullable<T[P]>;
};

export type Nullable<T> = T | null;

export type Nullish<T> = T | null | undefined;

export const FomanticShim = (...params: any[]) => ((window as any).$(...params) as {
    accordion(...params: any[]): any;
    calendar(...params: any[]): any;
    checkbox(...params: any[]): any;
    dropdown(...params: any[]): any;
    popup(...params: any[]): any;
    progress(...params: any[]): any;
    sidebar(...params: any[]): any;
    transition(...params: any[]): any;
});

export type UnderlyingType = "array" | "boolean" | "date" | "datestring" | "datetimestring" | "float" | "function" | "int" | "object" | "string";

export interface RadPromiseLike<T> extends PromiseLike<T>
{
    readonly [Symbol.toStringTag]: string;
    catch<TResult = never>(onrejected?: Nullable<((reason: any) => TResult | RadPromiseLike<TResult>) | undefined>): RadPromiseLike<T | TResult>;
    finally(onfinally?: Nullable<(() => void) | undefined>): Promise<T>;
    then<TResult1 = T, TResult2 = never>(onfulfilled?: Nullable<((value: T) => TResult1 | PromiseLike<TResult1>) | undefined>, onrejected?: Nullable<((reason: any) => TResult2 | PromiseLike<TResult2>) | undefined>): RadPromiseLike<TResult1 | TResult2>;
}

export type XMLHttpRequestLike = { response?: any, responseText?: string, responseType?: string, status?: number, statusText?: string };

export class DummyEvent
{
    public static classNamespace = NAMESPACE + "Extensions";
    public static className = "DummyEvent";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public data: { self: any };
    public originalEvent: Event;
    public path: EventTarget[];

    constructor(self: any)
    {
        this.data = { self };
        this.originalEvent = new CustomEvent("Dummy");
        this.path = [];
    }

    preventDefault(): void
    {

    }
    stopPropagation(): void
    {

    }
}

export interface INameDescription
{
    name: string;
    description: string;
}

export interface IIdentifiableEntity
{
    id: Nullable<string>;
}

export interface IVersionableEntity
{
    rowVersion: Nullable<string>;
}

export interface IEntityDto extends IIdentifiableEntity, IVersionableEntity
{
}

export interface IMetricStatistics<T>
{
    max: T;
    mean: T;
    median: T;
    min: T;
    mode: T;
    decimalPlaces: T;
    standardDeviation: T;
}

export interface IMetricStatisticsDouble extends IMetricStatistics<Nullable<number>>
{

}

export interface IMetricStatisticsTimespan extends IMetricStatistics<Nullable<string>>
{

}

export interface IPagedDataRequest
{
    orderBy: string;
    orderByDescending: boolean;
    searchText: string;
    skip: number;
    top: Nullable<number>;
}

export interface ISourceCodeHintOption
{
    type: string;
    value: string;
    description: string;
}

export interface ICodeLocation
{
    line: number;
    character: number;
}

export interface ISourceCodeHint
{
    options: ISourceCodeHintOption[];
    start: ICodeLocation;
    end: ICodeLocation;
}

export enum DiagnosticSeverityEnum
{
    hidden = "hidden",
    info = "info",
    warning = "warning",
    error = "error",
}

export interface ISourceCodeLintAnnotation
{
    severity: DiagnosticSeverityEnum;
    message: string;
    start: number;
    end: number;
}

export interface ISourceCodeLint
{
    annotations: ISourceCodeLintAnnotation[];
}

export interface IEvaluatorInfo
{
    text: string;
    type: string;
}

export type ConfigurableColumnsKeys<T extends object, S> = {
    [K in keyof T]: T[K] extends S ? K : never
}[keyof T];
